module.exports = __webpack_public_path__ + "img/mmap.91827e22.png";